import { FC } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import RouteConstants from '@/features/router/RouteConstants';
import { WhatsappInboxPanes } from '@/features/whatsappInbox/components/WhatsappInboxPanes';

export const WhatsappCampaignInboxView: FC = () => {
  const history = useHistory();
  const { conversationId } = useParams<{ conversationId?: string }>();

  return (
    <WhatsappInboxPanes
      selectedId={conversationId}
      onSelect={(id) => history.push(`${RouteConstants.whatsappCampaignInbox}/${id}`)}
      onBack={() => history.push(RouteConstants.whatsappCampaignInbox)}
    />
  );
};
